import { useEffect } from 'react';

/**
 * Hook para modales hand-rolled (no usan el primitivo <Modal>).
 * Agrega comportamiento a11y minimo:
 *  - Escape cierra el modal
 *  - Bloquea scroll del body mientras esta abierto
 *  - Restaura overflow previo al cerrar
 *
 * Uso:
 *   useModalKeyboard({ open: !!editUsuario, onClose: () => setEditUsuario(null) });
 *
 * En el JSX, recordar agregar al div del modal-overlay:
 *   role="dialog" aria-modal="true"
 *
 * Para a11y completo (focus trap, aria-labelledby) preferir migrar a <Modal /> de ./ui.
 */
export function useModalKeyboard({ open, onClose }) {
    useEffect(() => {
        if (!open) return;
        const handleKey = (e) => {
            if (e.key === 'Escape') {
                e.stopPropagation();
                onClose?.();
            }
        };
        window.addEventListener('keydown', handleKey);
        const prev = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
        return () => {
            window.removeEventListener('keydown', handleKey);
            document.body.style.overflow = prev;
        };
    }, [open, onClose]);
}
